<template>
  <div class="account">
    <div class="account__content">
      <p>
        <routerLink to="/messaging">&#8592; back to messages</routerLink>
      </p>
      <div>
        <div class="account__content--subject">Subject: Low Staff Turnout</div>
        <div class="account__content--body">
          <div>
            <div class="account__content--body-sender">
              <div>
                Hey,
                My staffs have not been coming to work, can you help me check what's going on?
              </div>
              <p>Nov 7, 09:18</p>
            </div>
          </div>

          <div>
            <div class="account__content--body-receiver">
              <div>
                Hello,
                We are currently investigating
              </div>
              <p>Nov 7, 09:18</p>
            </div>
          </div>

          <div>
            <div class="account__content--body-sender">
              <div>Thanks</div>
              <p>Nov 7, 09:18</p>
            </div>
          </div>
        </div>
        <div class="account__content--send">
          <div class="account__content--send-text">
            <textarea type="text" placeholder="Write a reply ..."></textarea>
          </div>
          <div class="account__content--send-attach">
            <font-awesome-icon icon="paperclip" />
            <input type="file" />
          </div>
          <div class="account__content--send-send">
            <font-awesome-icon icon="paper-plane" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MessageThread"
};
</script>

<style lang="scss" scoped>
.account {
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(217, 217, 217, 0.98);
  background-color: #ffffff;
  padding: 20px;

  > .account__content {
    > p {
      font-size: 0.729vw;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.21;
      letter-spacing: normal;
      text-align: left;
      color: #caced5;

      > a {
        text-decoration: none;
        color: #caced5;
      }
    }

    > div {
      margin-top: 50px;

      > .account__content--subject {
        font-size: 1.25vw;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.17;
        letter-spacing: normal;
        text-align: left;
        color: #5099de;
      }

      > .account__content--body {
        margin: 20px 0;
        height: 400px;
        overflow: auto;

        > div {
          overflow: hidden;
          .account__content--body-sender {
            width: 50%;
            float: right;
            > div {
              padding: 10px 7px;
              background-color: #edf9f7;
              border-radius: 5px;
              box-shadow: 0 1px 3px 0 rgba(217, 217, 217, 0.98);
              font-size: 0.833vw;
              font-weight: 200;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.43;
              letter-spacing: 0.7px;
              text-align: left;
              color: #000000;
            }

            > p {
              font-size: 0.625vw;
              font-weight: 300;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.33;
              letter-spacing: 0.6px;
              text-align: right;
              color: #bcc5d3;
              margin-top: 5px;
              text-align: right;
            }
          }

          .account__content--body-receiver {
            width: 50%;
            float: left;
            > div {
              padding: 10px 7px;
              background-color: #5099de;
              border-radius: 5px;
              box-shadow: 0 1px 3px 0 rgba(217, 217, 217, 0.98);
              font-size: 0.833vw;
              font-weight: 200;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.43;
              letter-spacing: 0.7px;
              text-align: left;
              color: #ffffff;
            }

            > p {
              font-size: 0.625vw;
              font-weight: 300;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.33;
              letter-spacing: 0.6px;
              text-align: right;
              color: #bcc5d3;
              margin-top: 5px;
              text-align: left;
            }
          }
        }
      }

      > .account__content--send {
        height: 40px;
        border: solid 1px #c7c7c7;
        background-color: #ffffff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        overflow: hidden;

        > .account__content--send-text {
          width: calc(100% - 80px);
          height: 40px;
          overflow: hidden;

          > textarea {
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            padding: 5px;
            resize: none;
            border: 0;
            outline: 0;
            font-size: 0.938vw;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.11;
            letter-spacing: normal;
            text-align: left;
            color: #777777;
          }
        }

        > .account__content--send-attach {
          width: 40px;
          height: 40px;
          text-align: center;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          color: #777777;
          position: relative;

          > input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            cursor: pointer;
          }
        }

        > .account__content--send-send {
          width: 40px;
          height: 40px;
          text-align: center;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          color: #777777;
          cursor: pointer;
        }
      }
    }
  }
}
</style>